import React from "react";
import ReactDOM from "react-dom";
import ErrorPage from "@radarly/app/pages/insight-pages/error";
import { ErrorBoundary } from "@radarly/shared/error-boundary";
import App from "./app";

if (process.env.MOCK_REQUESTS) {
  const { worker } = require("../../app/src/mocks/browser");
  worker.start();
}

ReactDOM.render(
  <ErrorBoundary fallback={<ErrorPage />}>
    <App />
  </ErrorBoundary>,
  document.getElementById("main")
);
